import React from 'react';
import '../css/Component/chargement.css';

const Chargement = () => {
  return (
    <div className="spinner-container">
      <div className="loading-spinner"></div>
      <p className="loading-text">Chargement...</p>
    </div>
  );
};

export default Chargement;
